import { apiClient } from './client'

export type PipelineKey = 'case' | 'lake' | 'dispatch'

export interface ProcessingHealth {
  workers: number
  rabbit_ok: boolean
  db_ok: boolean
  queue: string
}

export interface ProcessingQueue {
  queue: string
  ready: number
  unacked: number
  consumers: number
  publish_rate: number
  deliver_rate: number
  mgmt_url: string | null
}

export interface ProcessingActiveJob {
  job_id: string
  pipeline: string
  case_id: string | null
  document_id: string | null
  current_step: string | null
  started_at: string | null
  elapsed_ms: number
  eta_ms: number | null
}

export interface ProcessingStepMetric {
  name: string
  count: number
  avg_ms: number
  p50_ms: number
  p95_ms: number
  failure_rate: number
}

export interface ProcessingJobCounts {
  done: number
  failed: number
  running: number
  pending: number
}

export interface ProcessingMetrics {
  hours: number
  jobs: ProcessingJobCounts
  steps: ProcessingStepMetric[]
}

export interface ProcessingFailure {
  job_id: string
  step_name: string | null
  error: string
  ended_at: string | null
}

export interface ProcessingPipelineState {
  key: PipelineKey
  label: string
  has_jobs: boolean
  health: ProcessingHealth
  queue: ProcessingQueue | null
  active: ProcessingActiveJob[]
  metrics: ProcessingMetrics | null
  failures: ProcessingFailure[]
}

export interface ProcessingState {
  hours: number
  pipelines: ProcessingPipelineState[]
}

export const adminProcessingApi = {
  state: (hours = 24) =>
    apiClient.get<ProcessingState>(`/v1/admin/processing/state?hours=${hours}`),
}
